import { analytics } from './analytics'
import { errands } from './errands'
import { Feature } from '../pinia/feature'
import { info } from './info'
import { attachments } from './attachments'
import { assets } from './assets'
import { wip } from './wip'

const features: Feature = {
  name: 'digital-buildings',
  enabled: true,
  title: {
    en: 'Digital Buildings',
    sv: 'Digital Buildings'
  },
  children: [info, attachments, errands, assets, analytics, wip]
}

export default features
